import React from 'react';
import moment from 'moment'

import IClinicalMedicationHistory from '../interfaces/clinical-medication-history';

const FLAGS_TO_STATUS = {
  true: 'Current',
  false: 'Past'
};

const medicationDateFormat = 'MM/DD/YYYY HH:mm:ss';

const ClinicalMedicationHistoryListItem = ({ history }) => {
  const reporter = history.reporter || { role: 'System', fullName: 'N/A' };

  return (
    <tr>
      <td>{FLAGS_TO_STATUS[history.activelyTakingFlag]}</td>
      <td>{moment(history.createdAt).format(medicationDateFormat)}</td>
      <td>
        <span>{reporter.role}</span>
        <span> ({reporter.fullName})</span>
      </td>
    </tr>
  );
};

ClinicalMedicationHistoryListItem.propTypes = {
  history: IClinicalMedicationHistory
};

export default ClinicalMedicationHistoryListItem;
